import { useCallback, useRef } from 'react'

/**
 * Returns a handler that retains it's reference during every render
 */
export const useHandler = <T extends (...args: any[]) => any>(
  handler: T,
): T => {
  const handlerRef = useRef(handler)

  handlerRef.current = handler

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(((...args) => handlerRef.current(...args)) as T, [])
}
